var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { MAX_WIDTH_MENU } from './helpers';
import { Dropdown } from "../Dropdown";
import { SelectButton } from "../SelectButton";
import { createUIElement } from "../../helpers";
import { INDENT, View, VIEW_CONTENT_MOD } from "../../View";
import { MultipleChoiceContent } from './MultipleChoiceContent';
import { calcWidth } from "../../helpers/styles";
var getIndexByValue = function (data, value) {
    var len = data.length;
    while (len--) {
        if (data[len] && data[len].id === value) {
            return len;
        }
    }
    return 0;
};
var StyledSelectButton = styled(SelectButton)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n"], ["\n    ",
    "\n"])), function (_a) {
    var size = _a.size;
    if (size) {
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                max-width: ", ";\n            "], ["\n                max-width: ", ";\n            "])), typeof size === 'string' ? size : calcWidth(size));
    }
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            max-width: 100%;\n        "], ["\n            max-width: 100%;\n        "])));
});
var Button = createUIElement('Button', function (props, ref) {
    return React.createElement(StyledSelectButton, __assign({}, props, { ref: ref }));
});
export var defaultValueSorter = function (left, right, data) {
    var getIndex = function (id, data) {
        var result = -1;
        data.some(function (i, index) {
            if (i.id === id) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    };
    return getIndex(left, data) - getIndex(right, data);
};
var StyledView = styled(View)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    max-width: ", ";\n"], ["\n    max-width: ", ";\n"])), MAX_WIDTH_MENU);
export var MultipleChoice = createUIElement('MultipleChoice', function (_a, ref) {
    var className = _a.className, widthSize = _a.widthSize, // @Deprecated: use only size
    size = _a.size, disabled = _a.disabled, _b = _a.columnSize, columnSize = _b === void 0 ? 7 : _b, data = _a.data, error = _a.error, value = _a.value, _c = _a.placeholder, placeholder = _c === void 0 ? 'Not chosen...' : _c, onChange = _a.onChange, onMenuOpen = _a.onMenuOpen, onMenuClose = _a.onMenuClose, _d = _a.valueSorter, valueSorter = _d === void 0 ? defaultValueSorter : _d, titleFormatter = _a.titleFormatter, onFocus = _a.onFocus, onBlur = _a.onBlur, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "widthSize", "size", "disabled", "columnSize", "data", "error", "value", "placeholder", "onChange", "onMenuOpen", "onMenuClose", "valueSorter", "titleFormatter", "onFocus", "onBlur", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var rootRef = useRef(null);
    var buttonRef = ref || rootRef;
    var getSelected = function (prevSelectedState, value) {
        return value ? value.map(function (value) { return getIndexByValue(data, value); }) : prevSelectedState;
    };
    var _e = useState(getSelected([], value)), selected = _e[0], setSelected = _e[1];
    useEffect(function () {
        setSelected(getSelected(selected || [], value));
    }, [value]);
    var getSortValue = function (nextValue) {
        nextValue = nextValue || value;
        return nextValue && valueSorter
            ? nextValue.sort(function (a, b) { return valueSorter(a, b, data); })
            : nextValue;
    };
    var update = function (selected) {
        var nextValue = getSortValue(selected.map(function (idx) { return data[idx].id; })) || [];
        onChange === null || onChange === void 0 ? void 0 : onChange(nextValue);
        setSelected(selected);
    };
    var canSelectAll = function () { return selected.length !== data.length; };
    var canClearAll = function () { return !!selected.length; };
    var onToggleItem = function (index) {
        var filteredSelected = selected.filter(function (i) { return i !== index; });
        if (filteredSelected.length === selected.length) {
            filteredSelected.push(index);
        }
        update(filteredSelected);
    };
    var onClearAll = function () { return update([]); };
    var onSelectAll = function () { return update(data.map(function (_, idx) { return idx; })); };
    var isSelected = function (index) { return selected.indexOf(index) > -1; };
    var renderTitle = function () {
        var selectedItems = selected
            .map(function (idx) {
            return data[idx] || { id: '', name: '' };
        })
            .filter(function (i) { return !!i.name; });
        if (typeof valueSorter === 'function') {
            selectedItems = selectedItems.sort(function (a, b) { return valueSorter(a.id, b.id, data); });
        }
        if (typeof titleFormatter === 'function') {
            var title = titleFormatter(selectedItems);
            if (title) {
                return title;
            }
        }
        return selectedItems.map(function (i) { return i.name; }).join(', ');
    };
    return (React.createElement(Dropdown, { ref: buttonRef, renderControl: function (_a) {
            var button = _a.button, isActive = _a.isActive;
            return (React.createElement(Button, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'multiplechoice-main-control', className: "vm-MultipleChoice " + className, error: !disabled && error, size: size || widthSize, active: isActive, placeholder: placeholder, text: renderTitle(), disabled: disabled, onFocus: onFocus, onBlur: onBlur, onClick: onClick, onMouseDown: function (e) {
                    button.onMouseDown(e);
                    onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(e);
                }, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: button.ref, style: style })));
        }, onDidShow: onMenuOpen, onDidHide: onMenuClose, renderContent: function () { return (React.createElement(StyledView, { spaceHorizontal: INDENT.m, spaceVertical: INDENT.s, contentMod: VIEW_CONTENT_MOD.fill },
            React.createElement(MultipleChoiceContent, { isSelected: isSelected, columnSize: columnSize, data: data, onClearAll: onClearAll, onSelectAll: onSelectAll, onToggleItem: onToggleItem, canSelectAll: canSelectAll(), canClearAll: canClearAll() }))); } }));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=MultipleChoice.js.map